module.exports = __webpack_public_path__ + "img/symbol_7.f6c7a0e7.png";